module.exports = __webpack_public_path__ + "img/btn_lp_close.b3a500ae.svg";